import { render, staticRenderFns } from "./IntroEdit.vue?vue&type=template&id=624c8559&"
import script from "./IntroEdit.vue?vue&type=script&lang=js&"
export * from "./IntroEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports